import { render, staticRenderFns } from "./FormPaymentKasbonDriver.vue?vue&type=template&id=2d8b72dc"
import script from "./FormPaymentKasbonDriver.vue?vue&type=script&lang=js"
export * from "./FormPaymentKasbonDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports